// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function ButtonPrimary(Props) {
  let classesOpt = Props.classes;
  let label = Props.label;
  let onClickOpt = Props.onClick;
  let type_Opt = Props.type_;
  let isDisabledOpt = Props.isDisabled;
  const classes = classesOpt !== undefined ? classesOpt : /* [] */ 0;
  const onClick = onClickOpt !== undefined ? onClickOpt : (function (param) {
      
    });
  const type_ = type_Opt !== undefined ? type_Opt : "";
  const isDisabled = isDisabledOpt !== undefined ? isDisabledOpt : false;
  if (type_ === "submit") {
    return JsxRuntime.jsx("input", {
      className: Cn.fromList({
        hd: "h6 text-white rounded-lg py-3 px-8 bg-primary transition-all duration-200 ease-in-out cursor-pointer disabled:opacity-64 hover:bg-primary-hover active:bg-primary-active",
        tl: classes
      }),
      disabled: isDisabled,
      type: "submit",
      value: label
    });
  } else {
    return JsxRuntime.jsx("button", {
      children: label,
      className: Cn.fromList({
        hd: "h6 text-white rounded-lg py-3 px-8 bg-primary transition-all duration-200 ease-in-out cursor-pointer disabled:opacity-64 hover:bg-primary-hover active:bg-primary-active",
        tl: classes
      }),
      disabled: isDisabled,
      onClick: (function (param) {
        Curry._1(onClick, undefined);
      })
    });
  }
}

const make = ButtonPrimary;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
